/**
 * Feature Flags Configuration
 *
 * Use these flags to enable/disable features across the application.
 * Set to `true` to enable, `false` to disable.
 */

export const FEATURE_FLAGS = {
  /**
   * Pricing page and subscription UI
   * When disabled, hides pricing links and redirects /dashboard/pricing.html to dashboard
   */
  PRICING_PAGE: true,

  /**
   * Stripe payment integration
   * When disabled, upgrade buttons show "Coming Soon" instead of payment flow
   */
  STRIPE_PAYMENTS: true,

  /**
   * Organization/team features
   * When disabled, hides organization creation and team management
   */
  ORGANIZATIONS: true,

  /**
   * Advanced analytics dashboard
   * When disabled, shows basic metrics only
   */
  ADVANCED_ANALYTICS: true,

  /**
   * White-label customization
   * When disabled, white-label options are hidden even for Pro users
   */
  WHITE_LABEL: true,

  /**
   * Custom domain support
   * When disabled, custom domain options are hidden
   */
  CUSTOM_DOMAINS: false,

  /**
   * Self-host export feature
   * When disabled, hides export button even for enterprise/admin users
   */
  SELF_HOST_EXPORT: true,
} as const;

// Type for feature flag keys
export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

/**
 * Check if a feature is enabled
 */
export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  return FEATURE_FLAGS[flag] === true;
}

/**
 * Get all enabled features (useful for debugging)
 */
export function getEnabledFeatures(): FeatureFlagKey[] {
  return (Object.keys(FEATURE_FLAGS) as FeatureFlagKey[]).filter(
    (key) => FEATURE_FLAGS[key] === true
  );
}
